import yousersjs from '@yola/yousersjs';
import partner from 'src/js/modules/partner';
import analytics from 'src/js/modules/analytics';

const authWithGoogle = (userData) => async () => {
  const data = {
    ...userData,
    partner_id: partner.accessors.getPartnerId(),
  };

  try {
    const { visitorId, requestId } = await analytics.fingerprint.getVisitorData();

    data.vfp = visitorId;
    data.fprid = requestId;
  } catch (error) {
    console.error('[FP] Get data:', error);
  }

  return yousersjs.requests.authWithGoogle(data);
};

export default authWithGoogle;
